// extracted by mini-css-extract-plugin
module.exports = {"root":"slideshow-module--root--1tQZc","nav":"slideshow-module--nav--24WQk","carousel":"slideshow-module--carousel--2iXg7","slide":"slideshow-module--slide--B1gv3"};